import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface RouteMiddlewareProps {
  permissions?: string[];
  element: any;
}

const QuestionMiddleware: React.FC<RouteMiddlewareProps> = ({ element }) => {
  const { user } = useAuth();
  const location = useLocation();

  const hasVerifyTokenInMemory = !!user?.verifyToken;

  let hasVerifyTokenInStorage = false;

  try {
    const storedVerify = window.localStorage.getItem('zenbox.verify');

    if (storedVerify) {
      const parsedVerify = JSON.parse(storedVerify);
      hasVerifyTokenInStorage = !!parsedVerify?.verifyToken;
    }
  } catch {
    hasVerifyTokenInStorage = false;
  }

  const isAuthenticatedForQuestions =
    hasVerifyTokenInMemory || hasVerifyTokenInStorage;

  if (!isAuthenticatedForQuestions) {
    return <Navigate to="/signup" replace state={{ from: location }} />;
  }

  return element;
};

export default QuestionMiddleware;